export default { "columns":84,
 "image":"forest-ground-tileset.png",
 "imageheight":544,
 "imagewidth":1352,
 "margin":0,
 "name":"forest-ground-tileset",
 "spacing":0,
 "tilecount":2856,
 "tiledversion":"1.11.2",
 "tileheight":16,
 "tiles":[
        {
         "id":18,
         "type":"decal"
        }, 
        {
         "id":19,
         "type":"decal"
        }, 
        {
         "id":102,
         "objectgroup":
            {
             "draworder":"index",
             "id":2,
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":3,
                             "y":0
                            }, 
                            {
                             "x":11,
                             "y":-16
                            }, 
                            {
                             "x":11,
                             "y":0
                            }, 
                            {
                             "x":-5,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":5,
                     "y":16
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"slopediagleft"
        }, 
        {
         "id":103,
         "objectgroup":
            {
             "draworder":"index",
             "id":2,
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":8,
                             "y":16
                            }, 
                            {
                             "x":16,
                             "y":16
                            }, 
                            {
                             "x":0,
                             "y":16
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"slopediagright"
        }, 
        {
         "id":181,
         "type":"decal"
        }, 
        {
         "id":182,
         "type":"decal"
        }, 
        {
         "id":185,
         "type":"decal"
        }, 
        {
         "id":186,
         "objectgroup":
            {
             "draworder":"index",
             "id":2,
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":8,
                             "y":-7
                            }, 
                            {
                             "x":16,
                             "y":-7
                            }, 
                            {
                             "x":16,
                             "y":9
                            }, 
                            {
                             "x":0,
                             "y":9
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":7
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"slopediagleft"
        }, 
        {
         "id":187,
         "objectgroup":
            {
             "draworder":"index",
             "id":2,
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":-3,
                             "y":0
                            }, 
                            {
                             "x":5,
                             "y":16
                            }, 
                            {
                             "x":-11,
                             "y":16
                            }, 
                            {
                             "x":-11,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":11,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"slopediagright"
        }, 
        {
         "id":188,
         "type":"decal"
        }, 
        {
         "id":190,
         "type":"ground"
        }, 
        {
         "id":191,
         "type":"ground"
        }, 
        {
         "id":192,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":0,
                             "y":13
                            }, 
                            {
                             "x":-4,
                             "y":16
                            }, 
                            {
                             "x":-16,
                             "y":16
                            }, 
                            {
                             "x":-16,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":16,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":193,
         "type":"ground"
        }, 
        {
         "id":194,
         "type":"ground"
        }, 
        {
         "id":195,
         "type":"ground"
        }, 
        {
         "id":196,
         "type":"ground"
        }, 
        {
         "id":197,
         "type":"ground"
        }, 
        {
         "id":200,
         "type":"decal"
        }, 
        {
         "id":201,
         "type":"decal"
        }, 
        {
         "id":202,
         "type":"decal"
        }, 
        {
         "id":203,
         "type":"decal"
        }, 
        {
         "id":204,
         "type":"decal"
        }, 
        {
         "id":205,
         "type":"decal"
        }, 
        {
         "id":208,
         "type":"decal"
        }, 
        {
         "id":209,
         "type":"decal"
        }, 
        {
         "id":210,
         "type":"decal"
        }, 
        {
         "id":211,
         "type":"decal"
        }, 
        {
         "id":212,
         "type":"decal"
        }, 
        {
         "id":213,
         "type":"decal"
        }, 
        {
         "id":215,
         "type":"decal"
        }, 
        {
         "id":216,
         "type":"decal"
        }, 
        {
         "id":217,
         "type":"decal"
        }, 
        {
         "id":218,
         "type":"decal"
        }, 
        {
         "id":219,
         "type":"decal"
        }, 
        {
         "id":220,
         "type":"decal"
        }, 
        {
         "id":222,
         "type":"decal"
        }, 
        {
         "id":223,
         "type":"decal"
        }, 
        {
         "id":224,
         "type":"decal"
        }, 
        {
         "id":225,
         "type":"decal"
        }, 
        {
         "id":226,
         "type":"decal"
        }, 
        {
         "id":227,
         "type":"decal"
        }, 
        {
         "id":264,
         "type":"decal"
        }, 
        {
         "id":265,
         "objectgroup":
            {
             "draworder":"index",
             "id":2,
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":16,
                             "y":-10
                            }, 
                            {
                             "x":16,
                             "y":6
                            }, 
                            {
                             "x":0,
                             "y":6
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":10
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"slopediagleft"
        }, 
        {
         "id":266,
         "objectgroup":
            {
             "draworder":"index",
             "id":2,
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":16
                            }, 
                            {
                             "x":0,
                             "y":16
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"slopediagright"
        }, 
        {
         "id":267,
         "type":"decal"
        }, 
        {
         "id":269,
         "objectgroup":
            {
             "draworder":"index",
             "id":2,
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":3,
                             "y":0
                            }, 
                            {
                             "x":11,
                             "y":-16
                            }, 
                            {
                             "x":11,
                             "y":0
                            }, 
                            {
                             "x":-5,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":5,
                     "y":16
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"slopediagleft"
        }, 
        {
         "id":270,
         "type":"ground"
        }, 
        {
         "id":271,
         "type":"ground"
        }, 
        {
         "id":272,
         "objectgroup":
            {
             "draworder":"index",
             "id":2,
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":8,
                             "y":16
                            }, 
                            {
                             "x":16,
                             "y":16
                            }, 
                            {
                             "x":0,
                             "y":16
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"slopediagright"
        }, 
        {
         "id":274,
         "type":"ground"
        }, 
        {
         "id":275,
         "type":"ground"
        }, 
        {
         "id":276,
         "type":"decal"
        }, 
        {
         "id":280,
         "type":"ground"
        }, 
        {
         "id":281,
         "type":"ground"
        }, 
        {
         "id":284,
         "type":"ground"
        }, 
        {
         "id":285,
         "type":"ground"
        }, 
        {
         "id":286,
         "type":"ground"
        }, 
        {
         "id":287,
         "type":"ground"
        }, 
        {
         "id":288,
         "type":"ground"
        }, 
        {
         "id":289,
         "type":"ground"
        }, 
        {
         "id":292,
         "type":"ground"
        }, 
        {
         "id":293,
         "type":"ground"
        }, 
        {
         "id":294,
         "type":"ground"
        }, 
        {
         "id":295,
         "type":"ground"
        }, 
        {
         "id":296,
         "type":"ground"
        }, 
        {
         "id":297,
         "type":"ground"
        }, 
        {
         "id":299,
         "type":"ground"
        }, 
        {
         "id":300,
         "type":"ground"
        }, 
        {
         "id":301,
         "type":"ground"
        }, 
        {
         "id":302,
         "type":"ground"
        }, 
        {
         "id":303,
         "type":"ground"
        }, 
        {
         "id":304,
         "type":"ground"
        }, 
        {
         "id":306,
         "type":"ground"
        }, 
        {
         "id":307,
         "type":"ground"
        }, 
        {
         "id":308,
         "type":"ground"
        }, 
        {
         "id":309,
         "type":"ground"
        }, 
        {
         "id":310,
         "type":"ground"
        }, 
        {
         "id":311,
         "type":"ground"
        }, 
        {
         "id":344,
         "type":"decal"
        }, 
        {
         "id":345,
         "type":"decal"
        }, 
        {
         "id":348,
         "objectgroup":
            {
             "draworder":"index",
             "id":2,
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":16,
                             "y":-10
                            }, 
                            {
                             "x":16,
                             "y":6
                            }, 
                            {
                             "x":0,
                             "y":6
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":10
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"slopediagleft"
        }, 
        {
         "id":349,
         "type":"ground"
        }, 
        {
         "id":350,
         "type":"ground"
        }, 
        {
         "id":351,
         "objectgroup":
            {
             "draworder":"index",
             "id":2,
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":16
                            }, 
                            {
                             "x":0,
                             "y":16
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"slopediagright"
        }, 
        {
         "id":353,
         "objectgroup":
            {
             "draworder":"index",
             "id":2,
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":8,
                             "y":-8
                            }, 
                            {
                             "x":16,
                             "y":-8
                            }, 
                            {
                             "x":16,
                             "y":8
                            }, 
                            {
                             "x":0,
                             "y":8
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":8
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"slopediagleft"
        }, 
        {
         "id":354,
         "type":"ground"
        }, 
        {
         "id":355,
         "type":"ground"
        }, 
        {
         "id":356,
         "objectgroup":
            {
             "draworder":"index",
             "id":2,
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":-3,
                             "y":0
                            }, 
                            {
                             "x":5,
                             "y":16
                            }, 
                            {
                             "x":-11,
                             "y":16
                            }, 
                            {
                             "x":-11,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":11,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"slopediagright"
        }, 
        {
         "id":358,
         "type":"ground"
        }, 
        {
         "id":359,
         "type":"ground"
        }, 
        {
         "id":360,
         "type":"decal"
        }, 
        {
         "id":363,
         "type":"decal"
        }, 
        {
         "id":364,
         "type":"ground"
        }, 
        {
         "id":365,
         "type":"ground"
        }, 
        {
         "id":368,
         "type":"ground"
        }, 
        {
         "id":369,
         "type":"ground"
        }, 
        {
         "id":370,
         "type":"ground"
        }, 
        {
         "id":371,
         "type":"ground"
        }, 
        {
         "id":372,
         "type":"ground"
        }, 
        {
         "id":373,
         "type":"ground"
        }, 
        {
         "id":376,
         "type":"ground"
        }, 
        {
         "id":377,
         "type":"ground"
        }, 
        {
         "id":378,
         "type":"ground"
        }, 
        {
         "id":379,
         "type":"ground"
        }, 
        {
         "id":380,
         "type":"ground"
        }, 
        {
         "id":381,
         "type":"ground"
        }, 
        {
         "id":383,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":9,
                             "y":0
                            }, 
                            {
                             "x":9,
                             "y":8
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":7,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":384,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":15
                            }, 
                            {
                             "x":1,
                             "y":9
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":385,
         "type":"ground"
        }, 
        {
         "id":386,
         "type":"ground"
        }, 
        {
         "id":387,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":-5
                            }, 
                            {
                             "x":16,
                             "y":-14
                            }, 
                            {
                             "x":0,
                             "y":-14
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":14
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":388,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":-9,
                             "y":9
                            }, 
                            {
                             "x":-9,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":9,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":390,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":14,
                             "y":0
                            }, 
                            {
                             "x":14,
                             "y":13
                            }, 
                            {
                             "x":6,
                             "y":8
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":2,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":391,
         "type":"ground"
        }, 
        {
         "id":392,
         "type":"ground"
        }, 
        {
         "id":393,
         "type":"ground"
        }, 
        {
         "id":394,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":0
                            }, 
                            {
                             "x":15,
                             "y":16
                            }, 
                            {
                             "x":0,
                             "y":12
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":395,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":-6,
                             "y":8
                            }, 
                            {
                             "x":-14,
                             "y":13
                            }, 
                            {
                             "x":-14,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":14,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":422,
         "type":"decal"
        }, 
        {
         "id":423,
         "type":"decal"
        }, 
        {
         "id":424,
         "type":"decal"
        }, 
        {
         "id":425,
         "type":"decal"
        }, 
        {
         "id":427,
         "objectgroup":
            {
             "draworder":"index",
             "id":2,
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":16,
                             "y":-3
                            }, 
                            {
                             "x":16,
                             "y":5
                            }, 
                            {
                             "x":0,
                             "y":5
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":11
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"slopediagleft"
        }, 
        {
         "id":428,
         "objectgroup":
            {
             "draworder":"index",
             "id":2,
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":2
                            }, 
                            {
                             "x":16,
                             "y":-6
                            }, 
                            {
                             "x":16,
                             "y":10
                            }, 
                            {
                             "x":0,
                             "y":10
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":6
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"slopediagleft"
        }, 
        {
         "id":429,
         "objectgroup":
            {
             "draworder":"index",
             "id":2,
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":8
                            }, 
                            {
                             "x":16,
                             "y":16
                            }, 
                            {
                             "x":0,
                             "y":16
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"slopediagright"
        }, 
        {
         "id":430,
         "objectgroup":
            {
             "draworder":"index",
             "id":2,
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":2
                            }, 
                            {
                             "x":16,
                             "y":10
                            }, 
                            {
                             "x":0,
                             "y":10
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":6
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"slopediagright"
        }, 
        {
         "id":432,
         "type":"ground"
        }, 
        {
         "id":433,
         "type":"ground"
        }, 
        {
         "id":434,
         "type":"ground"
        }, 
        {
         "id":435,
         "type":"ground"
        }, 
        {
         "id":437,
         "type":"ground"
        }, 
        {
         "id":438,
         "type":"ground"
        }, 
        {
         "id":439,
         "type":"ground"
        }, 
        {
         "id":440,
         "type":"ground"
        }, 
        {
         "id":442,
         "type":"ground"
        }, 
        {
         "id":443,
         "type":"ground"
        }, 
        {
         "id":448,
         "type":"ground"
        }, 
        {
         "id":449,
         "type":"ground"
        }, 
        {
         "id":452,
         "type":"ground"
        }, 
        {
         "id":453,
         "type":"ground"
        }, 
        {
         "id":454,
         "type":"ground"
        }, 
        {
         "id":455,
         "type":"ground"
        }, 
        {
         "id":456,
         "type":"ground"
        }, 
        {
         "id":457,
         "type":"ground"
        }, 
        {
         "id":460,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":13,
                             "y":0
                            }, 
                            {
                             "x":13,
                             "y":13
                            }, 
                            {
                             "x":7,
                             "y":10
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":3,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":461,
         "type":"ground"
        }, 
        {
         "id":462,
         "type":"ground"
        }, 
        {
         "id":463,
         "type":"ground"
        }, 
        {
         "id":464,
         "type":"ground"
        }, 
        {
         "id":465,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":-2,
                             "y":5
                            }, 
                            {
                             "x":-13,
                             "y":13
                            }, 
                            {
                             "x":-13,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":13,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":506,
         "type":"ground"
        }, 
        {
         "id":507,
         "type":"ground"
        }, 
        {
         "id":508,
         "type":"ground"
        }, 
        {
         "id":509,
         "type":"ground"
        }, 
        {
         "id":511,
         "type":"ground"
        }, 
        {
         "id":512,
         "type":"ground"
        }, 
        {
         "id":513,
         "type":"ground"
        }, 
        {
         "id":514,
         "type":"ground"
        }, 
        {
         "id":516,
         "type":"ground"
        }, 
        {
         "id":517,
         "type":"ground"
        }, 
        {
         "id":518,
         "type":"ground"
        }, 
        {
         "id":519,
         "type":"ground"
        }, 
        {
         "id":521,
         "type":"ground"
        }, 
        {
         "id":522,
         "type":"ground"
        }, 
        {
         "id":523,
         "type":"ground"
        }, 
        {
         "id":524,
         "type":"ground"
        }, 
        {
         "id":526,
         "type":"ground"
        }, 
        {
         "id":527,
         "type":"ground"
        }, 
        {
         "id":528,
         "type":"decal"
        }, 
        {
         "id":531,
         "type":"decal"
        }, 
        {
         "id":532,
         "type":"ground"
        }, 
        {
         "id":533,
         "type":"ground"
        }, 
        {
         "id":535,
         "type":"decal"
        }, 
        {
         "id":536,
         "type":"ground"
        }, 
        {
         "id":537,
         "type":"ground"
        }, 
        {
         "id":538,
         "type":"ground"
        }, 
        {
         "id":539,
         "type":"ground"
        }, 
        {
         "id":540,
         "type":"ground"
        }, 
        {
         "id":541,
         "type":"ground"
        }, 
        {
         "id":542,
         "type":"decal"
        }, 
        {
         "id":590,
         "type":"ground"
        }, 
        {
         "id":591,
         "type":"ground"
        }, 
        {
         "id":592,
         "type":"ground"
        }, 
        {
         "id":593,
         "type":"ground"
        }, 
        {
         "id":595,
         "type":"ground"
        }, 
        {
         "id":596,
         "type":"ground"
        }, 
        {
         "id":597,
         "type":"ground"
        }, 
        {
         "id":598,
         "type":"ground"
        }, 
        {
         "id":600,
         "type":"ground"
        }, 
        {
         "id":601,
         "type":"ground"
        }, 
        {
         "id":602,
         "type":"ground"
        }, 
        {
         "id":603,
         "type":"ground"
        }, 
        {
         "id":605,
         "type":"ground"
        }, 
        {
         "id":606,
         "objectgroup":
            {
             "draworder":"index",
             "id":2,
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":-8,
                             "y":16
                            }, 
                            {
                             "x":-15,
                             "y":16
                            }, 
                            {
                             "x":-15,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":15,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":607,
         "objectgroup":
            {
             "draworder":"index",
             "id":2,
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":15,
                             "y":0
                            }, 
                            {
                             "x":15,
                             "y":16
                            }, 
                            {
                             "x":8,
                             "y":16
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":1,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":608,
         "type":"ground"
        }, 
        {
         "id":610,
         "type":"ground"
        }, 
        {
         "id":611,
         "type":"ground"
        }, 
        {
         "id":612,
         "type":"decal"
        }, 
        {
         "id":615,
         "type":"decal"
        }, 
        {
         "id":616,
         "type":"ground"
        }, 
        {
         "id":617,
         "type":"ground"
        }, 
        {
         "id":620,
         "type":"ground"
        }, 
        {
         "id":621,
         "type":"ground"
        }, 
        {
         "id":622,
         "type":"ground"
        }, 
        {
         "id":623,
         "type":"ground"
        }, 
        {
         "id":624,
         "type":"ground"
        }, 
        {
         "id":625,
         "type":"ground"
        }, 
        {
         "id":674,
         "type":"ground"
        }, 
        {
         "id":675,
         "type":"ground"
        }, 
        {
         "id":676,
         "type":"ground"
        }, 
        {
         "id":677,
         "type":"ground"
        }, 
        {
         "id":679,
         "type":"ground"
        }, 
        {
         "id":680,
         "type":"ground"
        }, 
        {
         "id":681,
         "type":"ground"
        }, 
        {
         "id":682,
         "type":"ground"
        }, 
        {
         "id":684,
         "type":"ground"
        }, 
        {
         "id":685,
         "type":"ground"
        }, 
        {
         "id":686,
         "type":"ground"
        }, 
        {
         "id":687,
         "type":"ground"
        }, 
        {
         "id":689,
         "type":"ground"
        }, 
        {
         "id":690,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":-7,
                             "y":14
                            }, 
                            {
                             "x":-7,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":7,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":691,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":7,
                             "y":0
                            }, 
                            {
                             "x":7,
                             "y":14
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":9,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":692,
         "type":"ground"
        }, 
        {
         "id":694,
         "type":"ground"
        }, 
        {
         "id":695,
         "type":"ground"
        }, 
        {
         "id":696,
         "type":"decal"
        }, 
        {
         "id":699,
         "type":"decal"
        }, 
        {
         "id":700,
         "type":"ground"
        }, 
        {
         "id":701,
         "type":"ground"
        }, 
        {
         "id":704,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":14,
                             "y":0
                            }, 
                            {
                             "x":14,
                             "y":13
                            }, 
                            {
                             "x":7,
                             "y":10
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":2,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":705,
         "type":"ground"
        }, 
        {
         "id":706,
         "type":"ground"
        }, 
        {
         "id":707,
         "type":"ground"
        }, 
        {
         "id":708,
         "type":"ground"
        }, 
        {
         "id":709,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":-7,
                             "y":10
                            }, 
                            {
                             "x":-14,
                             "y":13
                            }, 
                            {
                             "x":-14,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":14,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":758,
         "type":"ground"
        }, 
        {
         "id":759,
         "type":"ground"
        }, 
        {
         "id":760,
         "type":"ground"
        }, 
        {
         "id":761,
         "type":"ground"
        }, 
        {
         "id":763,
         "type":"ground"
        }, 
        {
         "id":764,
         "objectgroup":
            {
             "draworder":"index",
             "id":3,
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":-16,
                             "y":16
                            }, 
                            {
                             "x":-16,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":16,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":765,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":16
                            }, 
                            {
                             "x":16,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":766,
         "type":"ground"
        }, 
        {
         "id":768,
         "type":"ground"
        }, 
        {
         "id":769,
         "objectgroup":
            {
             "draworder":"index",
             "id":2,
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":-16,
                             "y":16
                            }, 
                            {
                             "x":-16,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":16,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":770,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":16
                            }, 
                            {
                             "x":16,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":771,
         "type":"ground"
        }, 
        {
         "id":773,
         "objectgroup":
            {
             "draworder":"index",
             "id":2,
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":-8,
                             "y":16
                            }, 
                            {
                             "x":-15,
                             "y":16
                            }, 
                            {
                             "x":-15,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":15,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":776,
         "objectgroup":
            {
             "draworder":"index",
             "id":2,
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":15,
                             "y":0
                            }, 
                            {
                             "x":15,
                             "y":16
                            }, 
                            {
                             "x":8,
                             "y":16
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":1,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":778,
         "type":"ground"
        }, 
        {
         "id":779,
         "type":"ground"
        }, 
        {
         "id":780,
         "type":"decal"
        }, 
        {
         "id":781,
         "type":"decal"
        }, 
        {
         "id":782,
         "type":"decal"
        }, 
        {
         "id":783,
         "type":"decal"
        }, 
        {
         "id":784,
         "type":"ground"
        }, 
        {
         "id":785,
         "type":"ground"
        }, 
        {
         "id":788,
         "type":"decal"
        }, 
        {
         "id":789,
         "type":"decal"
        }, 
        {
         "id":790,
         "type":"decal"
        }, 
        {
         "id":791,
         "type":"decal"
        }, 
        {
         "id":792,
         "type":"decal"
        }, 
        {
         "id":793,
         "type":"decal"
        }, 
        {
         "id":796,
         "type":"decal"
        }, 
        {
         "id":797,
         "type":"decal"
        }, 
        {
         "id":798,
         "type":"decal"
        }, 
        {
         "id":799,
         "type":"decal"
        }, 
        {
         "id":800,
         "type":"decal"
        }, 
        {
         "id":801,
         "type":"decal"
        }, 
        {
         "id":803,
         "type":"decal"
        }, 
        {
         "id":804,
         "type":"decal"
        }, 
        {
         "id":805,
         "type":"decal"
        }, 
        {
         "id":806,
         "type":"decal"
        }, 
        {
         "id":807,
         "type":"decal"
        }, 
        {
         "id":808,
         "type":"decal"
        }, 
        {
         "id":810,
         "type":"decal"
        }, 
        {
         "id":811,
         "type":"decal"
        }, 
        {
         "id":812,
         "type":"decal"
        }, 
        {
         "id":813,
         "type":"decal"
        }, 
        {
         "id":814,
         "type":"decal"
        }, 
        {
         "id":815,
         "type":"decal"
        }, 
        {
         "id":842,
         "type":"ground"
        }, 
        {
         "id":843,
         "type":"ground"
        }, 
        {
         "id":844,
         "type":"ground"
        }, 
        {
         "id":845,
         "type":"ground"
        }, 
        {
         "id":847,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":-14
                            }, 
                            {
                             "x":0,
                             "y":-14
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":14
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":850,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":14
                            }, 
                            {
                             "x":16,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":852,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":-13
                            }, 
                            {
                             "x":0,
                             "y":-13
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":13
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":855,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":13
                            }, 
                            {
                             "x":16,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":857,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":-7,
                             "y":14
                            }, 
                            {
                             "x":-7,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":7,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":860,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":7,
                             "y":0
                            }, 
                            {
                             "x":7,
                             "y":14
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":9,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":862,
         "type":"ground"
        }, 
        {
         "id":863,
         "type":"ground"
        }, 
        {
         "id":864,
         "type":"ground"
        }, 
        {
         "id":865,
         "type":"ground"
        }, 
        {
         "id":866,
         "type":"ground"
        }, 
        {
         "id":867,
         "type":"ground"
        }, 
        {
         "id":868,
         "type":"ground"
        }, 
        {
         "id":869,
         "type":"ground"
        }, 
        {
         "id":872,
         "type":"ground"
        }, 
        {
         "id":873,
         "type":"ground"
        }, 
        {
         "id":874,
         "type":"ground"
        }, 
        {
         "id":875,
         "type":"ground"
        }, 
        {
         "id":876,
         "type":"ground"
        }, 
        {
         "id":877,
         "type":"ground"
        }, 
        {
         "id":880,
         "type":"ground"
        }, 
        {
         "id":881,
         "type":"ground"
        }, 
        {
         "id":882,
         "type":"ground"
        }, 
        {
         "id":883,
         "type":"ground"
        }, 
        {
         "id":884,
         "type":"ground"
        }, 
        {
         "id":885,
         "type":"ground"
        }, 
        {
         "id":887,
         "type":"ground"
        }, 
        {
         "id":888,
         "type":"ground"
        }, 
        {
         "id":889,
         "type":"ground"
        }, 
        {
         "id":890,
         "type":"ground"
        }, 
        {
         "id":891,
         "type":"ground"
        }, 
        {
         "id":892,
         "type":"ground"
        }, 
        {
         "id":894,
         "type":"ground"
        }, 
        {
         "id":895,
         "type":"ground"
        }, 
        {
         "id":896,
         "type":"ground"
        }, 
        {
         "id":897,
         "type":"ground"
        }, 
        {
         "id":898,
         "type":"ground"
        }, 
        {
         "id":899,
         "type":"ground"
        }, 
        {
         "id":946,
         "type":"ground"
        }, 
        {
         "id":947,
         "type":"ground"
        }, 
        {
         "id":948,
         "type":"ground"
        }, 
        {
         "id":949,
         "type":"ground"
        }, 
        {
         "id":950,
         "type":"ground"
        }, 
        {
         "id":951,
         "type":"ground"
        }, 
        {
         "id":952,
         "type":"ground"
        }, 
        {
         "id":953,
         "type":"ground"
        }, 
        {
         "id":956,
         "type":"ground"
        }, 
        {
         "id":957,
         "type":"ground"
        }, 
        {
         "id":958,
         "type":"ground"
        }, 
        {
         "id":959,
         "type":"ground"
        }, 
        {
         "id":960,
         "type":"ground"
        }, 
        {
         "id":961,
         "type":"ground"
        }, 
        {
         "id":964,
         "type":"ground"
        }, 
        {
         "id":965,
         "type":"ground"
        }, 
        {
         "id":966,
         "type":"ground"
        }, 
        {
         "id":967,
         "type":"ground"
        }, 
        {
         "id":968,
         "type":"ground"
        }, 
        {
         "id":969,
         "type":"ground"
        }, 
        {
         "id":971,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":7,
                             "y":0
                            }, 
                            {
                             "x":7,
                             "y":6
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":9,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":972,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":8
                            }, 
                            {
                             "x":16,
                             "y":-6
                            }, 
                            {
                             "x":0,
                             "y":-6
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":6
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":973,
         "type":"ground"
        }, 
        {
         "id":974,
         "type":"ground"
        }, 
        {
         "id":975,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":-8
                            }, 
                            {
                             "x":16,
                             "y":-13
                            }, 
                            {
                             "x":0,
                             "y":-13
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":13
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":976,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":-6,
                             "y":5
                            }, 
                            {
                             "x":-6,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":6,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":978,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":14,
                             "y":0
                            }, 
                            {
                             "x":14,
                             "y":13
                            }, 
                            {
                             "x":6,
                             "y":8
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":2,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":979,
         "type":"ground"
        }, 
        {
         "id":980,
         "type":"ground"
        }, 
        {
         "id":981,
         "type":"ground"
        }, 
        {
         "id":982,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":0
                            }, 
                            {
                             "x":15,
                             "y":16
                            }, 
                            {
                             "x":0,
                             "y":12
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":983,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":-6,
                             "y":8
                            }, 
                            {
                             "x":-14,
                             "y":13
                            }, 
                            {
                             "x":-14,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":14,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":1026,
         "type":"decal"
        }, 
        {
         "id":1027,
         "type":"decal"
        }, 
        {
         "id":1030,
         "type":"ground"
        }, 
        {
         "id":1031,
         "type":"ground"
        }, 
        {
         "id":1032,
         "type":"ground"
        }, 
        {
         "id":1033,
         "type":"ground"
        }, 
        {
         "id":1034,
         "type":"ground"
        }, 
        {
         "id":1035,
         "type":"ground"
        }, 
        {
         "id":1036,
         "type":"ground"
        }, 
        {
         "id":1037,
         "type":"ground"
        }, 
        {
         "id":1040,
         "type":"ground"
        }, 
        {
         "id":1041,
         "type":"ground"
        }, 
        {
         "id":1042,
         "type":"ground"
        }, 
        {
         "id":1043,
         "type":"ground"
        }, 
        {
         "id":1044,
         "type":"ground"
        }, 
        {
         "id":1045,
         "type":"ground"
        }, 
        {
         "id":1048,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":13,
                             "y":0
                            }, 
                            {
                             "x":13,
                             "y":13
                            }, 
                            {
                             "x":7,
                             "y":10
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":3,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":1049,
         "type":"ground"
        }, 
        {
         "id":1050,
         "type":"ground"
        }, 
        {
         "id":1051,
         "type":"ground"
        }, 
        {
         "id":1052,
         "type":"ground"
        }, 
        {
         "id":1053,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":-2,
                             "y":5
                            }, 
                            {
                             "x":-13,
                             "y":13
                            }, 
                            {
                             "x":-13,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":13,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":1110,
         "objectgroup":
            {
             "draworder":"index",
             "id":2,
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":3,
                             "y":0
                            }, 
                            {
                             "x":11,
                             "y":-16
                            }, 
                            {
                             "x":11,
                             "y":0
                            }, 
                            {
                             "x":-5,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":5,
                     "y":16
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"slopediagleft"
        }, 
        {
         "id":1111,
         "objectgroup":
            {
             "draworder":"index",
             "id":2,
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":8,
                             "y":16
                            }, 
                            {
                             "x":16,
                             "y":16
                            }, 
                            {
                             "x":0,
                             "y":16
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"slopediagright"
        }, 
        {
         "id":1123,
         "type":"decal"
        }, 
        {
         "id":1124,
         "type":"ground"
        }, 
        {
         "id":1125,
         "type":"ground"
        }, 
        {
         "id":1126,
         "type":"ground"
        }, 
        {
         "id":1127,
         "type":"ground"
        }, 
        {
         "id":1128,
         "type":"ground"
        }, 
        {
         "id":1129,
         "type":"ground"
        }, 
        {
         "id":1130,
         "type":"decal"
        }, 
        {
         "id":1189,
         "type":"decal"
        }, 
        {
         "id":1190,
         "type":"decal"
        }, 
        {
         "id":1193,
         "type":"decal"
        }, 
        {
         "id":1194,
         "objectgroup":
            {
             "draworder":"index",
             "id":2,
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":8,
                             "y":-7
                            }, 
                            {
                             "x":16,
                             "y":-7
                            }, 
                            {
                             "x":16,
                             "y":9
                            }, 
                            {
                             "x":0,
                             "y":9
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":7
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"slopediagleft"
        }, 
        {
         "id":1195,
         "objectgroup":
            {
             "draworder":"index",
             "id":2,
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":-3,
                             "y":0
                            }, 
                            {
                             "x":5,
                             "y":16
                            }, 
                            {
                             "x":-11,
                             "y":16
                            }, 
                            {
                             "x":-11,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":11,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"slopediagright"
        }, 
        {
         "id":1196,
         "type":"decal"
        }, 
        {
         "id":1198,
         "type":"ground"
        }, 
        {
         "id":1199,
         "type":"ground"
        }, 
        {
         "id":1200,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":11
                            }, 
                            {
                             "x":16,
                             "y":16
                            }, 
                            {
                             "x":0,
                             "y":16
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"slopediagright"
        }, 
        {
         "id":1201,
         "type":"decal"
        }, 
        {
         "id":1202,
         "type":"decal"
        }, 
        {
         "id":1203,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":-11
                            }, 
                            {
                             "x":16,
                             "y":5
                            }, 
                            {
                             "x":0,
                             "y":5
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":11
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"slopediagleft"
        }, 
        {
         "id":1204,
         "type":"ground"
        }, 
        {
         "id":1205,
         "type":"ground"
        }, 
        {
         "id":1208,
         "type":"ground"
        }, 
        {
         "id":1209,
         "type":"ground"
        }, 
        {
         "id":1210,
         "type":"ground"
        }, 
        {
         "id":1211,
         "type":"ground"
        }, 
        {
         "id":1212,
         "type":"ground"
        }, 
        {
         "id":1213,
         "type":"ground"
        }, 
        {
         "id":1268,
         "type":"decal"
        }, 
        {
         "id":1269,
         "type":"decal"
        }, 
        {
         "id":1272,
         "type":"decal"
        }, 
        {
         "id":1273,
         "objectgroup":
            {
             "draworder":"index",
             "id":2,
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":16,
                             "y":-9
                            }, 
                            {
                             "x":16,
                             "y":7
                            }, 
                            {
                             "x":0,
                             "y":7
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":9
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"slopediagleft"
        }, 
        {
         "id":1274,
         "objectgroup":
            {
             "draworder":"index",
             "id":2,
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":16
                            }, 
                            {
                             "x":0,
                             "y":16
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"slopediagright"
        }, 
        {
         "id":1275,
         "type":"decal"
        }, 
        {
         "id":1277,
         "objectgroup":
            {
             "draworder":"index",
             "id":2,
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":3,
                             "y":0
                            }, 
                            {
                             "x":11,
                             "y":-16
                            }, 
                            {
                             "x":11,
                             "y":0
                            }, 
                            {
                             "x":-5,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":5,
                     "y":16
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"slopediagleft"
        }, 
        {
         "id":1278,
         "type":"ground"
        }, 
        {
         "id":1279,
         "type":"ground"
        }, 
        {
         "id":1280,
         "objectgroup":
            {
             "draworder":"index",
             "id":2,
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":8,
                             "y":16
                            }, 
                            {
                             "x":16,
                             "y":16
                            }, 
                            {
                             "x":0,
                             "y":16
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"slopediagright"
        }, 
        {
         "id":1282,
         "type":"ground"
        }, 
        {
         "id":1283,
         "type":"ground"
        }, 
        {
         "id":1284,
         "type":"ground"
        }, 
        {
         "id":1285,
         "type":"ground"
        }, 
        {
         "id":1286,
         "type":"ground"
        }, 
        {
         "id":1287,
         "type":"ground"
        }, 
        {
         "id":1288,
         "type":"ground"
        }, 
        {
         "id":1289,
         "type":"ground"
        }, 
        {
         "id":1292,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":14,
                             "y":0
                            }, 
                            {
                             "x":14,
                             "y":13
                            }, 
                            {
                             "x":7,
                             "y":10
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":2,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":1293,
         "type":"ground"
        }, 
        {
         "id":1294,
         "type":"ground"
        }, 
        {
         "id":1295,
         "type":"ground"
        }, 
        {
         "id":1296,
         "type":"ground"
        }, 
        {
         "id":1297,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":-7,
                             "y":10
                            }, 
                            {
                             "x":-14,
                             "y":13
                            }, 
                            {
                             "x":-14,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":14,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":1346,
         "type":"decal"
        }, 
        {
         "id":1347,
         "type":"decal"
        }, 
        {
         "id":1348,
         "type":"decal"
        }, 
        {
         "id":1349,
         "type":"decal"
        }, 
        {
         "id":1351,
         "objectgroup":
            {
             "draworder":"index",
             "id":2,
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":16,
                             "y":-3
                            }, 
                            {
                             "x":16,
                             "y":5
                            }, 
                            {
                             "x":0,
                             "y":5
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":11
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"slopediagleft"
        }, 
        {
         "id":1352,
         "objectgroup":
            {
             "draworder":"index",
             "id":2,
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":2
                            }, 
                            {
                             "x":16,
                             "y":-6
                            }, 
                            {
                             "x":16,
                             "y":10
                            }, 
                            {
                             "x":0,
                             "y":10
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":6
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"slopediagleft"
        }, 
        {
         "id":1353,
         "objectgroup":
            {
             "draworder":"index",
             "id":2,
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":8
                            }, 
                            {
                             "x":16,
                             "y":16
                            }, 
                            {
                             "x":0,
                             "y":16
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"slopediagright"
        }, 
        {
         "id":1354,
         "objectgroup":
            {
             "draworder":"index",
             "id":2,
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":2
                            }, 
                            {
                             "x":16,
                             "y":10
                            }, 
                            {
                             "x":0,
                             "y":10
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":6
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"slopediagright"
        }, 
        {
         "id":1356,
         "objectgroup":
            {
             "draworder":"index",
             "id":2,
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":16,
                             "y":-3
                            }, 
                            {
                             "x":16,
                             "y":13
                            }, 
                            {
                             "x":0,
                             "y":13
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":3
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"slopediagleft"
        }, 
        {
         "id":1357,
         "type":"ground"
        }, 
        {
         "id":1358,
         "type":"ground"
        }, 
        {
         "id":1359,
         "objectgroup":
            {
             "draworder":"index",
             "id":2,
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":16
                            }, 
                            {
                             "x":0,
                             "y":16
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"slopediagright"
        }, 
        {
         "id":1361,
         "objectgroup":
            {
             "draworder":"index",
             "id":2,
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":8,
                             "y":-8
                            }, 
                            {
                             "x":16,
                             "y":-8
                            }, 
                            {
                             "x":16,
                             "y":8
                            }, 
                            {
                             "x":0,
                             "y":8
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":8
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"slopediagleft"
        }, 
        {
         "id":1362,
         "type":"ground"
        }, 
        {
         "id":1363,
         "type":"ground"
        }, 
        {
         "id":1364,
         "objectgroup":
            {
             "draworder":"index",
             "id":2,
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":-3,
                             "y":0
                            }, 
                            {
                             "x":5,
                             "y":16
                            }, 
                            {
                             "x":-11,
                             "y":16
                            }, 
                            {
                             "x":-11,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":11,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"slopediagright"
        }, 
        {
         "id":1366,
         "type":"ground"
        }, 
        {
         "id":1367,
         "type":"ground"
        }, 
        {
         "id":1368,
         "type":"ground"
        }, 
        {
         "id":1369,
         "type":"ground"
        }, 
        {
         "id":1370,
         "type":"ground"
        }, 
        {
         "id":1371,
         "type":"ground"
        }, 
        {
         "id":1372,
         "type":"ground"
        }, 
        {
         "id":1373,
         "type":"ground"
        }, 
        {
         "id":1430,
         "type":"ground"
        }, 
        {
         "id":1431,
         "type":"ground"
        }, 
        {
         "id":1432,
         "type":"ground"
        }, 
        {
         "id":1433,
         "type":"ground"
        }, 
        {
         "id":1435,
         "type":"ground"
        }, 
        {
         "id":1436,
         "type":"ground"
        }, 
        {
         "id":1437,
         "type":"ground"
        }, 
        {
         "id":1438,
         "type":"ground"
        }, 
        {
         "id":1440,
         "type":"ground"
        }, 
        {
         "id":1441,
         "type":"ground"
        }, 
        {
         "id":1442,
         "type":"ground"
        }, 
        {
         "id":1443,
         "type":"ground"
        }, 
        {
         "id":1445,
         "type":"ground"
        }, 
        {
         "id":1446,
         "type":"ground"
        }, 
        {
         "id":1447,
         "type":"ground"
        }, 
        {
         "id":1448,
         "type":"ground"
        }, 
        {
         "id":1450,
         "type":"ground"
        }, 
        {
         "id":1451,
         "type":"ground"
        }, 
        {
         "id":1452,
         "type":"ground"
        }, 
        {
         "id":1453,
         "type":"ground"
        }, 
        {
         "id":1454,
         "type":"ground"
        }, 
        {
         "id":1455,
         "type":"ground"
        }, 
        {
         "id":1456,
         "type":"ground"
        }, 
        {
         "id":1457,
         "type":"ground"
        }, 
        {
         "id":1460,
         "type":"decal"
        }, 
        {
         "id":1461,
         "type":"decal"
        }, 
        {
         "id":1462,
         "type":"decal"
        }, 
        {
         "id":1463,
         "type":"decal"
        }, 
        {
         "id":1464,
         "type":"decal"
        }, 
        {
         "id":1465,
         "type":"decal"
        }, 
        {
         "id":1468,
         "type":"decal"
        }, 
        {
         "id":1469,
         "type":"decal"
        }, 
        {
         "id":1470,
         "type":"decal"
        }, 
        {
         "id":1471,
         "type":"decal"
        }, 
        {
         "id":1472,
         "type":"decal"
        }, 
        {
         "id":1473,
         "type":"decal"
        }, 
        {
         "id":1475,
         "type":"decal"
        }, 
        {
         "id":1476,
         "type":"decal"
        }, 
        {
         "id":1477,
         "type":"decal"
        }, 
        {
         "id":1478,
         "type":"decal"
        }, 
        {
         "id":1479,
         "type":"decal"
        }, 
        {
         "id":1480,
         "type":"decal"
        }, 
        {
         "id":1482,
         "type":"decal"
        }, 
        {
         "id":1483,
         "type":"decal"
        }, 
        {
         "id":1484,
         "type":"decal"
        }, 
        {
         "id":1485,
         "type":"decal"
        }, 
        {
         "id":1486,
         "type":"decal"
        }, 
        {
         "id":1487,
         "type":"decal"
        }, 
        {
         "id":1514,
         "type":"ground"
        }, 
        {
         "id":1515,
         "type":"ground"
        }, 
        {
         "id":1516,
         "type":"ground"
        }, 
        {
         "id":1517,
         "type":"ground"
        }, 
        {
         "id":1519,
         "type":"ground"
        }, 
        {
         "id":1520,
         "type":"ground"
        }, 
        {
         "id":1521,
         "type":"ground"
        }, 
        {
         "id":1522,
         "type":"ground"
        }, 
        {
         "id":1524,
         "type":"ground"
        }, 
        {
         "id":1525,
         "type":"ground"
        }, 
        {
         "id":1526,
         "type":"ground"
        }, 
        {
         "id":1527,
         "type":"ground"
        }, 
        {
         "id":1529,
         "type":"ground"
        }, 
        {
         "id":1530,
         "objectgroup":
            {
             "draworder":"index",
             "id":2,
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":-8,
                             "y":16
                            }, 
                            {
                             "x":-15,
                             "y":16
                            }, 
                            {
                             "x":-15,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":15,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":1531,
         "objectgroup":
            {
             "draworder":"index",
             "id":2,
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":15,
                             "y":0
                            }, 
                            {
                             "x":15,
                             "y":16
                            }, 
                            {
                             "x":8,
                             "y":16
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":1,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":1532,
         "type":"ground"
        }, 
        {
         "id":1544,
         "type":"ground"
        }, 
        {
         "id":1545,
         "type":"ground"
        }, 
        {
         "id":1546,
         "type":"ground"
        }, 
        {
         "id":1547,
         "type":"ground"
        }, 
        {
         "id":1548,
         "type":"ground"
        }, 
        {
         "id":1549,
         "type":"ground"
        }, 
        {
         "id":1552,
         "type":"ground"
        }, 
        {
         "id":1553,
         "type":"ground"
        }, 
        {
         "id":1554,
         "type":"ground"
        }, 
        {
         "id":1555,
         "type":"ground"
        }, 
        {
         "id":1556,
         "type":"ground"
        }, 
        {
         "id":1557,
         "type":"ground"
        }, 
        {
         "id":1559,
         "type":"ground"
        }, 
        {
         "id":1560,
         "type":"ground"
        }, 
        {
         "id":1561,
         "type":"ground"
        }, 
        {
         "id":1562,
         "type":"ground"
        }, 
        {
         "id":1563,
         "type":"ground"
        }, 
        {
         "id":1564,
         "type":"ground"
        }, 
        {
         "id":1566,
         "type":"ground"
        }, 
        {
         "id":1567,
         "type":"ground"
        }, 
        {
         "id":1568,
         "type":"ground"
        }, 
        {
         "id":1569,
         "type":"ground"
        }, 
        {
         "id":1570,
         "type":"ground"
        }, 
        {
         "id":1571,
         "type":"ground"
        }, 
        {
         "id":1598,
         "type":"ground"
        }, 
        {
         "id":1599,
         "type":"ground"
        }, 
        {
         "id":1600,
         "type":"ground"
        }, 
        {
         "id":1601,
         "type":"ground"
        }, 
        {
         "id":1603,
         "type":"ground"
        }, 
        {
         "id":1604,
         "type":"ground"
        }, 
        {
         "id":1605,
         "type":"ground"
        }, 
        {
         "id":1606,
         "type":"ground"
        }, 
        {
         "id":1608,
         "type":"ground"
        }, 
        {
         "id":1609,
         "type":"ground"
        }, 
        {
         "id":1610,
         "type":"ground"
        }, 
        {
         "id":1611,
         "type":"ground"
        }, 
        {
         "id":1613,
         "type":"ground"
        }, 
        {
         "id":1614,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":-7,
                             "y":14
                            }, 
                            {
                             "x":-7,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":7,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":1615,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":7,
                             "y":0
                            }, 
                            {
                             "x":7,
                             "y":14
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":9,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":1616,
         "type":"ground"
        }, 
        {
         "id":1618,
         "type":"ground"
        }, 
        {
         "id":1619,
         "type":"ground"
        }, 
        {
         "id":1620,
         "objectgroup":
            {
             "draworder":"index",
             "id":2,
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":16
                            }, 
                            {
                             "x":0,
                             "y":16
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"slopediagright"
        }, 
        {
         "id":1621,
         "type":"decal"
        }, 
        {
         "id":1622,
         "type":"decal"
        }, 
        {
         "id":1623,
         "objectgroup":
            {
             "draworder":"index",
             "id":2,
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":16,
                             "y":-10
                            }, 
                            {
                             "x":16,
                             "y":6
                            }, 
                            {
                             "x":0,
                             "y":6
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":10
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"slopediagleft"
        }, 
        {
         "id":1624,
         "type":"ground"
        }, 
        {
         "id":1625,
         "type":"ground"
        }, 
        {
         "id":1628,
         "type":"ground"
        }, 
        {
         "id":1629,
         "type":"ground"
        }, 
        {
         "id":1630,
         "type":"ground"
        }, 
        {
         "id":1631,
         "type":"ground"
        }, 
        {
         "id":1632,
         "type":"ground"
        }, 
        {
         "id":1633,
         "type":"ground"
        }, 
        {
         "id":1636,
         "type":"ground"
        }, 
        {
         "id":1637,
         "type":"ground"
        }, 
        {
         "id":1638,
         "type":"ground"
        }, 
        {
         "id":1639,
         "type":"ground"
        }, 
        {
         "id":1640,
         "type":"ground"
        }, 
        {
         "id":1641,
         "type":"ground"
        }, 
        {
         "id":1643,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":7,
                             "y":0
                            }, 
                            {
                             "x":7,
                             "y":6
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":9,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":1644,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":8
                            }, 
                            {
                             "x":16,
                             "y":-6
                            }, 
                            {
                             "x":0,
                             "y":-6
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":6
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":1645,
         "type":"ground"
        }, 
        {
         "id":1646,
         "type":"ground"
        }, 
        {
         "id":1647,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":-7
                            }, 
                            {
                             "x":16,
                             "y":-13
                            }, 
                            {
                             "x":0,
                             "y":-13
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":13
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":1648,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":-7,
                             "y":6
                            }, 
                            {
                             "x":-7,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":7,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":1650,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":14,
                             "y":0
                            }, 
                            {
                             "x":14,
                             "y":13
                            }, 
                            {
                             "x":6,
                             "y":8
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":2,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":1651,
         "type":"ground"
        }, 
        {
         "id":1652,
         "type":"ground"
        }, 
        {
         "id":1653,
         "type":"ground"
        }, 
        {
         "id":1654,
         "type":"ground"
        }, 
        {
         "id":1655,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":-6,
                             "y":8
                            }, 
                            {
                             "x":-14,
                             "y":13
                            }, 
                            {
                             "x":-14,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":14,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":1682,
         "type":"ground"
        }, 
        {
         "id":1683,
         "type":"ground"
        }, 
        {
         "id":1684,
         "type":"ground"
        }, 
        {
         "id":1685,
         "type":"ground"
        }, 
        {
         "id":1687,
         "type":"ground"
        }, 
        {
         "id":1688,
         "objectgroup":
            {
             "draworder":"index",
             "id":2,
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":-16,
                             "y":16
                            }, 
                            {
                             "x":-16,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":16,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":1689,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":16
                            }, 
                            {
                             "x":16,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":1690,
         "type":"ground"
        }, 
        {
         "id":1692,
         "type":"ground"
        }, 
        {
         "id":1693,
         "objectgroup":
            {
             "draworder":"index",
             "id":2,
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":-16,
                             "y":16
                            }, 
                            {
                             "x":-16,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":16,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":1694,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":16
                            }, 
                            {
                             "x":16,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":1695,
         "type":"ground"
        }, 
        {
         "id":1697,
         "objectgroup":
            {
             "draworder":"index",
             "id":2,
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":-8,
                             "y":16
                            }, 
                            {
                             "x":-15,
                             "y":16
                            }, 
                            {
                             "x":-15,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":15,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":1700,
         "objectgroup":
            {
             "draworder":"index",
             "id":2,
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":15,
                             "y":0
                            }, 
                            {
                             "x":15,
                             "y":16
                            }, 
                            {
                             "x":8,
                             "y":16
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":1,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":1702,
         "type":"ground"
        }, 
        {
         "id":1703,
         "type":"ground"
        }, 
        {
         "id":1704,
         "type":"ground"
        }, 
        {
         "id":1705,
         "type":"ground"
        }, 
        {
         "id":1706,
         "type":"ground"
        }, 
        {
         "id":1707,
         "type":"ground"
        }, 
        {
         "id":1708,
         "type":"ground"
        }, 
        {
         "id":1709,
         "type":"ground"
        }, 
        {
         "id":1712,
         "type":"ground"
        }, 
        {
         "id":1713,
         "type":"ground"
        }, 
        {
         "id":1714,
         "type":"ground"
        }, 
        {
         "id":1715,
         "type":"ground"
        }, 
        {
         "id":1716,
         "type":"ground"
        }, 
        {
         "id":1717,
         "type":"ground"
        }, 
        {
         "id":1720,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":13,
                             "y":0
                            }, 
                            {
                             "x":13,
                             "y":13
                            }, 
                            {
                             "x":7,
                             "y":10
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":3,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":1721,
         "type":"ground"
        }, 
        {
         "id":1722,
         "type":"ground"
        }, 
        {
         "id":1723,
         "type":"ground"
        }, 
        {
         "id":1724,
         "type":"ground"
        }, 
        {
         "id":1725,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":-2,
                             "y":5
                            }, 
                            {
                             "x":-13,
                             "y":13
                            }, 
                            {
                             "x":-13,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":13,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":1766,
         "type":"ground"
        }, 
        {
         "id":1767,
         "type":"ground"
        }, 
        {
         "id":1768,
         "type":"ground"
        }, 
        {
         "id":1769,
         "type":"ground"
        }, 
        {
         "id":1771,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":-14
                            }, 
                            {
                             "x":0,
                             "y":-14
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":14
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":1774,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":14
                            }, 
                            {
                             "x":16,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":1776,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":-13
                            }, 
                            {
                             "x":0,
                             "y":-13
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":13
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":1779,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":13
                            }, 
                            {
                             "x":16,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":1781,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":-7,
                             "y":14
                            }, 
                            {
                             "x":-7,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":7,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":1784,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":7,
                             "y":0
                            }, 
                            {
                             "x":7,
                             "y":14
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":9,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":1786,
         "type":"ground"
        }, 
        {
         "id":1787,
         "type":"ground"
        }, 
        {
         "id":1788,
         "type":"ground"
        }, 
        {
         "id":1789,
         "type":"ground"
        }, 
        {
         "id":1790,
         "type":"ground"
        }, 
        {
         "id":1791,
         "type":"ground"
        }, 
        {
         "id":1792,
         "type":"ground"
        }, 
        {
         "id":1793,
         "type":"ground"
        }, 
        {
         "id":1795,
         "type":"decal"
        }, 
        {
         "id":1796,
         "type":"ground"
        }, 
        {
         "id":1797,
         "type":"ground"
        }, 
        {
         "id":1798,
         "type":"ground"
        }, 
        {
         "id":1799,
         "type":"ground"
        }, 
        {
         "id":1800,
         "type":"ground"
        }, 
        {
         "id":1801,
         "type":"ground"
        }, 
        {
         "id":1802,
         "type":"decal"
        }, 
        {
         "id":1870,
         "type":"ground"
        }, 
        {
         "id":1871,
         "type":"ground"
        }, 
        {
         "id":1872,
         "type":"ground"
        }, 
        {
         "id":1873,
         "type":"ground"
        }, 
        {
         "id":1874,
         "type":"ground"
        }, 
        {
         "id":1875,
         "type":"ground"
        }, 
        {
         "id":1876,
         "type":"ground"
        }, 
        {
         "id":1877,
         "type":"ground"
        }, 
        {
         "id":1880,
         "type":"ground"
        }, 
        {
         "id":1881,
         "type":"ground"
        }, 
        {
         "id":1882,
         "type":"ground"
        }, 
        {
         "id":1883,
         "type":"ground"
        }, 
        {
         "id":1884,
         "type":"ground"
        }, 
        {
         "id":1885,
         "type":"ground"
        }, 
        {
         "id":1950,
         "objectgroup":
            {
             "draworder":"index",
             "id":2,
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":5,
                             "y":0
                            }, 
                            {
                             "x":13,
                             "y":-16
                            }, 
                            {
                             "x":13,
                             "y":0
                            }, 
                            {
                             "x":-3,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":3,
                     "y":16
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"slopediagleft"
        }, 
        {
         "id":1951,
         "objectgroup":
            {
             "draworder":"index",
             "id":2,
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":8,
                             "y":16
                            }, 
                            {
                             "x":16,
                             "y":16
                            }, 
                            {
                             "x":0,
                             "y":16
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"slopediagright"
        }, 
        {
         "id":1964,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":14,
                             "y":0
                            }, 
                            {
                             "x":14,
                             "y":13
                            }, 
                            {
                             "x":7,
                             "y":10
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":2,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":1965,
         "type":"ground"
        }, 
        {
         "id":1966,
         "type":"ground"
        }, 
        {
         "id":1967,
         "type":"ground"
        }, 
        {
         "id":1968,
         "type":"ground"
        }, 
        {
         "id":1969,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":-7,
                             "y":10
                            }, 
                            {
                             "x":-14,
                             "y":13
                            }, 
                            {
                             "x":-14,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":14,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":2029,
         "type":"decal"
        }, 
        {
         "id":2030,
         "type":"decal"
        }, 
        {
         "id":2033,
         "type":"decal"
        }, 
        {
         "id":2034,
         "objectgroup":
            {
             "draworder":"index",
             "id":2,
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":8,
                             "y":-3
                            }, 
                            {
                             "x":16,
                             "y":-3
                            }, 
                            {
                             "x":16,
                             "y":13
                            }, 
                            {
                             "x":0,
                             "y":13
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":3
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"slopediagleft"
        }, 
        {
         "id":2035,
         "objectgroup":
            {
             "draworder":"index",
             "id":2,
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":-5,
                             "y":0
                            }, 
                            {
                             "x":3,
                             "y":16
                            }, 
                            {
                             "x":-13,
                             "y":16
                            }, 
                            {
                             "x":-13,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":13,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"slopediagright"
        }, 
        {
         "id":2036,
         "type":"decal"
        }, 
        {
         "id":2108,
         "type":"decal"
        }, 
        {
         "id":2109,
         "type":"decal"
        }, 
        {
         "id":2112,
         "type":"decal"
        }, 
        {
         "id":2113,
         "objectgroup":
            {
             "draworder":"index",
             "id":2,
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":16,
                             "y":-11
                            }, 
                            {
                             "x":16,
                             "y":5
                            }, 
                            {
                             "x":0,
                             "y":5
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":11
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"slopediagleft"
        }, 
        {
         "id":2114,
         "objectgroup":
            {
             "draworder":"index",
             "id":2,
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":16
                            }, 
                            {
                             "x":0,
                             "y":16
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"slopediagright"
        }, 
        {
         "id":2115,
         "type":"decal"
        }, 
        {
         "id":2117,
         "objectgroup":
            {
             "draworder":"index",
             "id":2,
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":2,
                             "y":0
                            }, 
                            {
                             "x":10,
                             "y":-16
                            }, 
                            {
                             "x":10,
                             "y":0
                            }, 
                            {
                             "x":-6,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":6,
                     "y":16
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"slopediagleft"
        }, 
        {
         "id":2118,
         "type":"ground"
        }, 
        {
         "id":2119,
         "type":"ground"
        }, 
        {
         "id":2120,
         "objectgroup":
            {
             "draworder":"index",
             "id":2,
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":8,
                             "y":16
                            }, 
                            {
                             "x":16,
                             "y":16
                            }, 
                            {
                             "x":0,
                             "y":16
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"slopediagright"
        }, 
        {
         "id":2122,
         "type":"decal"
        }, 
        {
         "id":2123,
         "type":"decal"
        }, 
        {
         "id":2124,
         "type":"decal"
        }, 
        {
         "id":2125,
         "type":"decal"
        }, 
        {
         "id":2126,
         "type":"decal"
        }, 
        {
         "id":2127,
         "type":"decal"
        }, 
        {
         "id":2128,
         "type":"decal"
        }, 
        {
         "id":2129,
         "type":"decal"
        }, 
        {
         "id":2130,
         "type":"decal"
        }, 
        {
         "id":2131,
         "type":"decal"
        }, 
        {
         "id":2186,
         "type":"decal"
        }, 
        {
         "id":2187,
         "type":"decal"
        }, 
        {
         "id":2188,
         "type":"decal"
        }, 
        {
         "id":2189,
         "type":"decal"
        }, 
        {
         "id":2191,
         "objectgroup":
            {
             "draworder":"index",
             "id":2,
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":16,
                             "y":-3
                            }, 
                            {
                             "x":16,
                             "y":5
                            }, 
                            {
                             "x":0,
                             "y":5
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":11
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"slopediagleft"
        }, 
        {
         "id":2192,
         "objectgroup":
            {
             "draworder":"index",
             "id":2,
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":1
                            }, 
                            {
                             "x":16,
                             "y":-6
                            }, 
                            {
                             "x":16,
                             "y":10
                            }, 
                            {
                             "x":0,
                             "y":10
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":6
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"slopediagleft"
        }, 
        {
         "id":2193,
         "objectgroup":
            {
             "draworder":"index",
             "id":2,
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":8
                            }, 
                            {
                             "x":16,
                             "y":16
                            }, 
                            {
                             "x":0,
                             "y":16
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"slopediagright"
        }, 
        {
         "id":2194,
         "objectgroup":
            {
             "draworder":"index",
             "id":2,
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":2
                            }, 
                            {
                             "x":16,
                             "y":10
                            }, 
                            {
                             "x":0,
                             "y":10
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":6
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"slopediagright"
        }, 
        {
         "id":2196,
         "objectgroup":
            {
             "draworder":"index",
             "id":2,
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":16,
                             "y":-11
                            }, 
                            {
                             "x":16,
                             "y":5
                            }, 
                            {
                             "x":0,
                             "y":5
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":11
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"slopediagleft"
        }, 
        {
         "id":2197,
         "type":"ground"
        }, 
        {
         "id":2198,
         "type":"ground"
        }, 
        {
         "id":2199,
         "objectgroup":
            {
             "draworder":"index",
             "id":2,
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":16
                            }, 
                            {
                             "x":0,
                             "y":16
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"slopediagright"
        }, 
        {
         "id":2201,
         "objectgroup":
            {
             "draworder":"index",
             "id":2,
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":8,
                             "y":-10
                            }, 
                            {
                             "x":16,
                             "y":-10
                            }, 
                            {
                             "x":16,
                             "y":6
                            }, 
                            {
                             "x":0,
                             "y":6
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":10
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"slopediagleft"
        }, 
        {
         "id":2202,
         "type":"ground"
        }, 
        {
         "id":2203,
         "type":"ground"
        }, 
        {
         "id":2204,
         "objectgroup":
            {
             "draworder":"index",
             "id":2,
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":-2,
                             "y":0
                            }, 
                            {
                             "x":6,
                             "y":16
                            }, 
                            {
                             "x":-10,
                             "y":16
                            }, 
                            {
                             "x":-10,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":10,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"slopediagright"
        }, 
        {
         "id":2206,
         "type":"ground"
        }, 
        {
         "id":2207,
         "type":"ground"
        }, 
        {
         "id":2208,
         "type":"ground"
        }, 
        {
         "id":2209,
         "type":"ground"
        }, 
        {
         "id":2210,
         "type":"ground"
        }, 
        {
         "id":2211,
         "type":"ground"
        }, 
        {
         "id":2212,
         "type":"ground"
        }, 
        {
         "id":2213,
         "type":"ground"
        }, 
        {
         "id":2214,
         "type":"ground"
        }, 
        {
         "id":2215,
         "type":"ground"
        }, 
        {
         "id":2270,
         "type":"ground"
        }, 
        {
         "id":2271,
         "type":"ground"
        }, 
        {
         "id":2272,
         "type":"ground"
        }, 
        {
         "id":2273,
         "type":"ground"
        }, 
        {
         "id":2275,
         "type":"ground"
        }, 
        {
         "id":2276,
         "type":"ground"
        }, 
        {
         "id":2277,
         "type":"ground"
        }, 
        {
         "id":2278,
         "type":"ground"
        }, 
        {
         "id":2280,
         "type":"ground"
        }, 
        {
         "id":2281,
         "type":"ground"
        }, 
        {
         "id":2282,
         "type":"ground"
        }, 
        {
         "id":2283,
         "type":"ground"
        }, 
        {
         "id":2285,
         "type":"ground"
        }, 
        {
         "id":2286,
         "type":"ground"
        }, 
        {
         "id":2287,
         "type":"ground"
        }, 
        {
         "id":2288,
         "type":"ground"
        }, 
        {
         "id":2290,
         "type":"ground"
        }, 
        {
         "id":2291,
         "type":"ground"
        }, 
        {
         "id":2292,
         "type":"ground"
        }, 
        {
         "id":2293,
         "type":"ground"
        }, 
        {
         "id":2294,
         "type":"ground"
        }, 
        {
         "id":2295,
         "type":"ground"
        }, 
        {
         "id":2296,
         "type":"ground"
        }, 
        {
         "id":2297,
         "type":"ground"
        }, 
        {
         "id":2298,
         "type":"ground"
        }, 
        {
         "id":2299,
         "type":"ground"
        }, 
        {
         "id":2354,
         "type":"ground"
        }, 
        {
         "id":2355,
         "type":"ground"
        }, 
        {
         "id":2356,
         "type":"ground"
        }, 
        {
         "id":2357,
         "type":"ground"
        }, 
        {
         "id":2359,
         "type":"ground"
        }, 
        {
         "id":2360,
         "type":"ground"
        }, 
        {
         "id":2361,
         "type":"ground"
        }, 
        {
         "id":2362,
         "type":"ground"
        }, 
        {
         "id":2364,
         "type":"ground"
        }, 
        {
         "id":2365,
         "type":"ground"
        }, 
        {
         "id":2366,
         "type":"ground"
        }, 
        {
         "id":2367,
         "type":"ground"
        }, 
        {
         "id":2369,
         "type":"ground"
        }, 
        {
         "id":2370,
         "objectgroup":
            {
             "draworder":"index",
             "id":2,
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":-8,
                             "y":16
                            }, 
                            {
                             "x":-15,
                             "y":16
                            }, 
                            {
                             "x":-15,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":15,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":2371,
         "objectgroup":
            {
             "draworder":"index",
             "id":2,
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":15,
                             "y":0
                            }, 
                            {
                             "x":15,
                             "y":16
                            }, 
                            {
                             "x":8,
                             "y":16
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":1,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":2372,
         "type":"ground"
        }, 
        {
         "id":2374,
         "type":"ground"
        }, 
        {
         "id":2375,
         "type":"ground"
        }, 
        {
         "id":2376,
         "type":"ground"
        }, 
        {
         "id":2377,
         "type":"ground"
        }, 
        {
         "id":2378,
         "type":"ground"
        }, 
        {
         "id":2379,
         "type":"ground"
        }, 
        {
         "id":2380,
         "type":"ground"
        }, 
        {
         "id":2381,
         "type":"ground"
        }, 
        {
         "id":2382,
         "type":"ground"
        }, 
        {
         "id":2383,
         "type":"ground"
        }, 
        {
         "id":2438,
         "type":"ground"
        }, 
        {
         "id":2439,
         "type":"ground"
        }, 
        {
         "id":2440,
         "type":"ground"
        }, 
        {
         "id":2441,
         "type":"ground"
        }, 
        {
         "id":2443,
         "type":"ground"
        }, 
        {
         "id":2444,
         "type":"ground"
        }, 
        {
         "id":2445,
         "type":"ground"
        }, 
        {
         "id":2446,
         "type":"ground"
        }, 
        {
         "id":2448,
         "type":"ground"
        }, 
        {
         "id":2449,
         "type":"ground"
        }, 
        {
         "id":2450,
         "type":"ground"
        }, 
        {
         "id":2451,
         "type":"ground"
        }, 
        {
         "id":2453,
         "type":"ground"
        }, 
        {
         "id":2454,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":-7,
                             "y":14
                            }, 
                            {
                             "x":-7,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":7,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":2455,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":7,
                             "y":0
                            }, 
                            {
                             "x":7,
                             "y":14
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":9,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":2456,
         "type":"ground"
        }, 
        {
         "id":2458,
         "type":"decal"
        }, 
        {
         "id":2459,
         "type":"decal"
        }, 
        {
         "id":2460,
         "type":"decal"
        }, 
        {
         "id":2461,
         "type":"decal"
        }, 
        {
         "id":2462,
         "type":"decal"
        }, 
        {
         "id":2463,
         "type":"decal"
        }, 
        {
         "id":2464,
         "type":"decal"
        }, 
        {
         "id":2465,
         "type":"decal"
        }, 
        {
         "id":2466,
         "type":"decal"
        }, 
        {
         "id":2467,
         "type":"decal"
        }, 
        {
         "id":2522,
         "type":"ground"
        }, 
        {
         "id":2523,
         "type":"ground"
        }, 
        {
         "id":2524,
         "type":"ground"
        }, 
        {
         "id":2525,
         "type":"ground"
        }, 
        {
         "id":2527,
         "type":"ground"
        }, 
        {
         "id":2528,
         "objectgroup":
            {
             "draworder":"index",
             "id":2,
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":-16,
                             "y":16
                            }, 
                            {
                             "x":-16,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":16,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":2529,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":16
                            }, 
                            {
                             "x":16,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":2530,
         "type":"ground"
        }, 
        {
         "id":2532,
         "type":"ground"
        }, 
        {
         "id":2533,
         "objectgroup":
            {
             "draworder":"index",
             "id":2,
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":-16,
                             "y":16
                            }, 
                            {
                             "x":-16,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":16,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":2534,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":16
                            }, 
                            {
                             "x":16,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":2535,
         "type":"ground"
        }, 
        {
         "id":2537,
         "objectgroup":
            {
             "draworder":"index",
             "id":2,
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":-8,
                             "y":16
                            }, 
                            {
                             "x":-15,
                             "y":16
                            }, 
                            {
                             "x":-15,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":15,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":2540,
         "objectgroup":
            {
             "draworder":"index",
             "id":2,
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":15,
                             "y":0
                            }, 
                            {
                             "x":15,
                             "y":16
                            }, 
                            {
                             "x":8,
                             "y":16
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":1,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":2542,
         "type":"ground"
        }, 
        {
         "id":2543,
         "type":"ground"
        }, 
        {
         "id":2544,
         "type":"ground"
        }, 
        {
         "id":2545,
         "type":"ground"
        }, 
        {
         "id":2546,
         "type":"ground"
        }, 
        {
         "id":2547,
         "type":"ground"
        }, 
        {
         "id":2548,
         "type":"ground"
        }, 
        {
         "id":2549,
         "type":"ground"
        }, 
        {
         "id":2550,
         "type":"ground"
        }, 
        {
         "id":2551,
         "type":"ground"
        }, 
        {
         "id":2606,
         "type":"ground"
        }, 
        {
         "id":2607,
         "type":"ground"
        }, 
        {
         "id":2608,
         "type":"ground"
        }, 
        {
         "id":2609,
         "type":"ground"
        }, 
        {
         "id":2611,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":-14
                            }, 
                            {
                             "x":0,
                             "y":-14
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":14
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":2614,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":14
                            }, 
                            {
                             "x":16,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":2616,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":-13
                            }, 
                            {
                             "x":0,
                             "y":-13
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":13
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":2619,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":13
                            }, 
                            {
                             "x":16,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":2621,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":-7,
                             "y":14
                            }, 
                            {
                             "x":-7,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":7,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":2624,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":7,
                             "y":0
                            }, 
                            {
                             "x":7,
                             "y":14
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":9,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":2626,
         "type":"ground"
        }, 
        {
         "id":2627,
         "type":"ground"
        }, 
        {
         "id":2628,
         "type":"ground"
        }, 
        {
         "id":2629,
         "type":"ground"
        }, 
        {
         "id":2630,
         "type":"ground"
        }, 
        {
         "id":2631,
         "type":"ground"
        }, 
        {
         "id":2632,
         "type":"ground"
        }, 
        {
         "id":2633,
         "type":"ground"
        }, 
        {
         "id":2634,
         "type":"ground"
        }, 
        {
         "id":2635,
         "type":"ground"
        }, 
        {
         "id":2710,
         "type":"ground"
        }, 
        {
         "id":2711,
         "type":"ground"
        }, 
        {
         "id":2712,
         "type":"ground"
        }, 
        {
         "id":2713,
         "type":"ground"
        }, 
        {
         "id":2714,
         "type":"ground"
        }, 
        {
         "id":2715,
         "type":"ground"
        }, 
        {
         "id":2716,
         "type":"ground"
        }, 
        {
         "id":2717,
         "type":"ground"
        }, 
        {
         "id":2718,
         "type":"ground"
        }, 
        {
         "id":2719,
         "type":"ground"
        }],
 "tilewidth":16,
 "type":"tileset",
 "version":"1.10"
};